export const getFilesFromInputChangeEvent = (event) => {
    // Convert FileList to File[] https://w3c.github.io/FileAPI/#filelist-section
    return Array.from(event.target.files || []);
};
